import React, { useRef } from "react";

interface InputWithLabelProps {
  value: string | number | undefined;
  setValue: (value: string | number) => void;
  label: string;
  placeholder: string;
  type?: string;
  noNegative?: boolean;
  maxLength?: number;
  inputClassName?: string;
}

const InputWithLabel: React.FC<InputWithLabelProps> = ({
  value,
  setValue,
  label,
  placeholder,
  type = "text",
  noNegative = false,
  maxLength = 140,
  inputClassName = "",
}) => {
  const inputRef = useRef<HTMLInputElement>(null);

  const handleChange = (newValue: string) => {
    if (type === "number" && noNegative && parseFloat(newValue) < 0) {
      return;
    }
    setValue(newValue);
  };

  return (
    <div className="relative grow">
      <label className="absolute -top-2 left-2 bg-white px-1 text-xs font-medium text-main-text-darker rounded-full">
        {label}
      </label>
      <div className="flex w-full">
        <input
          type={type}
          placeholder={placeholder}
          value={value}
          onChange={(e) => handleChange(e.target.value)}
          min={type === "number" && noNegative ? "0" : undefined}
          ref={inputRef}
          maxLength={maxLength}
          className={`block w-full h-10 sm:h-14 border-gray-300 py-1.5 text-main-text-darker shadow-sm placeholder:text-gray-400 focus:ring-inset focus:ring-blue-600 rounded-md ${inputClassName}`}
        />
      </div>
    </div>
  );
};

export default InputWithLabel;
